import { HEADER_MEGA_MENUS, HEADER_SIMPLE_LINKS } from './headerNavigation';

/**
 * Footer sütunları — `HEADER_MEGA_MENUS` ile header mega menüleriyle aynı bağlantılar.
 * @returns {{ id: string, titleKey: string, links: { linkKey: string, to: string }[] }[]}
 */
export function getFooterMegaSections() {
    return HEADER_MEGA_MENUS.map((menu) => ({
        id: menu.id,
        titleKey: menu.labelKey,
        links: menu.columns.flat().map((link) => ({
            linkKey: link.linkKey,
            to: link.to,
        })),
    }));
}

/**
 * Header’daki Haberler / Toplantılar / İletişim satırı.
 * @returns {{ linkKey: string, to: string, end?: boolean }[]}
 */
export function getFooterSimpleLinks() {
    return HEADER_SIMPLE_LINKS.map(({ linkKey, to }) => ({
        linkKey,
        to,
    }));
}
